import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import { Dialog, DialogContent, DialogTitle, Grid, IconButton, Typography } from "@mui/material";
import type { IpAddressAllowListDto } from "client/api/CloudSubscriptionApi";
import { activateCloudSubscriptionIpAddressAllowList } from "client/api/CloudSubscriptionApi";
import { SubmittableForm } from "components/form/SubmittableForm";

type CloudSubscriptionActivateIpAddressAllowListDialogProps = {
  cloudSubscriptionId: string;
  ipAddressAllowList: IpAddressAllowListDto;
  activate: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
  open: boolean;
};

export function CloudSubscriptionActivateIpAddressAllowListDialog(
  props: CloudSubscriptionActivateIpAddressAllowListDialogProps
) {
  const { cloudSubscriptionId, ipAddressAllowList, activate, onClose, onConfirm, open } = props;

  const handleSubmit = async () => {
    await activateCloudSubscriptionIpAddressAllowList(cloudSubscriptionId, activate);
    await onConfirm();
  };

  return (
    <Dialog onClose={onClose} open={open}>
      <DialogTitle>
        {activate ? "Activate" : "Deactivate"} IP address allow listing
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={2} rowSpacing={2}>
          <Grid size={12}>
            <SubmittableForm submitAction={handleSubmit} onCancel={onClose}>
              {() => {
                return (
                  <Grid size={12}>
                    {activate && ipAddressAllowList.allowedIpPrefixes.length === 0 && (
                      <Typography
                        sx={{
                          marginBottom: "16px",
                        }}
                      >
                        Activating IP address allow list with no list entries will result in the customer{" "}
                        <strong>only</strong> being able to access this instance via Azure Private Link.
                      </Typography>
                    )}
                    <Typography
                      sx={{
                        marginBottom: "16px",
                      }}
                    >
                      Changes to IP address allow lists can take up to 60 seconds to take effect.
                    </Typography>
                  </Grid>
                );
              }}
            </SubmittableForm>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
}
